var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button btn-back is-primary-ghost-small",on:{"click":function($event){_vm.$emit('click')}}},[(_vm.showArrow)?_c('left-arrow'):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.backButtonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }